// Active.jsx
import "../../../../design/active.css";
import React, { useEffect, useState, useRef } from "react";
import api from "../../../../api/API_SERVERS";
import { logout } from "../../../../utils/functions/multiUseFunctions";
import Toast from "../../../../utils/components/Toast";
import Loading from "../../../../utils/components/Loading";

import ProfileSection from "../../../other/logged_in/options/active/ProfileSection";
import PasswordSection from "../../../other/logged_in/options/active/PasswordSection";
import SubjectsSection from "../../../other/logged_in/options/active/SubjectsSection";

export default function Active() {
    const [activeTab, setActiveTab] = useState("profile");
    const [teacher, setTeacher] = useState(null);
    const [formData, setFormData] = useState({});
    const [originalData, setOriginalData] = useState(null);
    const [accessDate, setAccessDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [toast, setToast] = useState(null);

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

    const sidebarRef = useRef(null);
    const touchStartX = useRef(null);
    const touchEndX = useRef(null);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const showToast = (message, type = "error") => setToast({ message, type });

    const getTeacherProfile = async () => {
        try {
            const res = await api.get("/api/teachers/profile/get-profile-details-for-update");
            setTeacher(res.data.teacher);
            setFormData(res.data.teacher);
            setOriginalData(res.data.teacher);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const getAccessDate = async () => {
        try {
            const res = await api.get("/api/teachers/profile/subscription-status");
            const date = new Date(res.data.expires_at);

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            setAccessDate(`${day}/${month}/${year}`);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getTeacherProfile();
        getAccessDate();
    }, []);

    const handleTouchStart = (e) => touchStartX.current = e.changedTouches[0].screenX;
    const handleTouchEnd = (e) => {
        touchEndX.current = e.changedTouches[0].screenX;
        handleSwipe();
    };

    const handleSwipe = () => {
        if (touchStartX.current === null || touchEndX.current === null) return;
        const diff = touchEndX.current - touchStartX.current;
        if (diff > 80) setSidebarOpen(true);
        else if (diff < -80) setSidebarOpen(false);
        touchStartX.current = null;
        touchEndX.current = null;
    };

    const handleMenuButtonClick = (tab) => {
        setActiveTab(tab);
        if (!isDesktop) setSidebarOpen(false);
    };

    const handleClickOutside = (e) => {
        if (!isDesktop && sidebarRef.current && !sidebarRef.current.contains(e.target) && !e.target.closest('.mobile-menu-trigger')) {
            setSidebarOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
        // eslint-disable-next-line
    }, [isDesktop]);

    if (loading) return <Loading />;

    return (
        <div className="dashboard-container" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

            {!isDesktop && (
                <button className="mobile-menu-trigger" onClick={() => setSidebarOpen(!sidebarOpen)}>
                    {sidebarOpen ? "✕" : "☰"}
                </button>
            )}

            <div className={`sidebar-glass ${sidebarOpen ? "open" : "closed"}`} ref={sidebarRef}>
                <div className="sidebar-content">
                    <div className="brand-logo">Teacher<span>Hub</span></div>

                    <nav className="nav-menu">
                        <button className={activeTab === "profile" ? "active" : ""} onClick={() => handleMenuButtonClick("profile")}>
                            <span className="icon">👤</span> პირადი ინფორმაცია
                        </button>
                        <button className={activeTab === "subjects" ? "active" : ""} onClick={() => handleMenuButtonClick("subjects")}>
                            <span className="icon">📚</span> საგნები
                        </button>
                        <button className={activeTab === "password" ? "active" : ""} onClick={() => handleMenuButtonClick("password")}>
                            <span className="icon">🔐</span> პაროლი
                        </button>
                    </nav>

                    <div className="sidebar-footer">
                        <div className="access-info">წვდომა: {accessDate}</div>
                        <button className="logout-btn" onClick={logout}>🚪 გასვლა</button>
                    </div>
                </div>
            </div>

            <main className="main-content">
                <div className="glass-panel">
                    {activeTab === "profile" && (
                        <ProfileSection
                            teacher={teacher}
                            formData={formData}
                            setFormData={setFormData}
                            originalData={originalData}
                            setOriginalData={setOriginalData}
                            accessDate={accessDate}
                            showToast={showToast}
                        />
                    )}
                    {activeTab === "password" && <PasswordSection showToast={showToast} />}
                    {activeTab === "subjects" && (
                        <SubjectsSection
                            formData={formData}
                            setFormData={setFormData}
                            showToast={showToast}
                        />
                    )}
                </div>
            </main>
        </div>
    );
}